var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6031_766)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5502 108.255C100.096 108.255 115.94 92.4104 115.94 72.8651C115.94 53.3197 100.096 37.4751 80.5502 37.4751C61.0048 37.4751 45.1602 53.3197 45.1602 72.8651C45.1602 92.4104 61.0048 108.255 80.5502 108.255Z",
    fill: "#00A5D5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1001 64.1251C70.3314 64.1251 84.3001 50.1564 84.3001 32.9251C84.3001 15.6938 70.3314 1.7251 53.1001 1.7251C35.8689 1.7251 21.9001 15.6938 21.9001 32.9251C21.9001 50.1564 35.8689 64.1251 53.1001 64.1251Z",
    fill: "#FF009D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4101 95.2752C43.7536 95.2752 53.7601 85.2688 53.7601 72.9252C53.7601 60.5816 43.7536 50.5752 31.4101 50.5752C19.0665 50.5752 9.06006 60.5816 9.06006 72.9252C9.06006 85.2688 19.0665 95.2752 31.4101 95.2752Z",
    fill: "#FFDF00"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.38 31.6849V1.0249H86.0601",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.689941 87.2251V117.895H32.0099",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4099 117.975H118.07V86.6548",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.87 1.28467H1.20996V32.6047",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.04 74.655C38.04 74.655 57.85 94.425 81.71 74.585",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.78 33.6548V44.3648",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.22 33.6548V44.3648",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6031_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.38,
    height: 117.95,
    fill: "white",
    transform: "translate(0.189941 0.524902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLogo4);
export default __webpack_public_path__ + "static/media/illustration-logo-4.e72f2b86ed65f77702c7c8b0f328ec7b.svg";
export { ForwardRef as ReactComponent };